import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@app/material.module";
import { UserAvatarModule } from "@app/shared/user-avatar/user-avatar.module";
import { TranslateModule } from "@ngx-translate/core";
import { UserSinglePickerDialogComponent } from "./user-single-picker-dialog.component";

@NgModule({
	declarations: [UserSinglePickerDialogComponent],
	imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule, UserAvatarModule, TranslateModule],
	exports: [UserSinglePickerDialogComponent],
})
export class UserSinglePickerDialogModule {}
